<div class="columns mt-5 container is-fluid">

  <div class="column mt-3 ml-3 has-border" style="border-radius: 15px; padding-right: 0 !important;">
    <div class="product__box__description ">
      <span class="is-bold" style="color: #73b1d6">Grundbuchauszug</span> zur
      Eigentümerverifikation und Nachweis
      des berechtigten Interesses enthalten*
    </div>
    <div  class=" product__box__description check-wrapper">
      <ul>
        <li  *ngFor="let document of package.documents">
             <span >
                 <strong>{{getLongName(document)}}</strong>
             </span>
        </li>
      </ul>
    </div>

    <div *ngIf="package.additionalDocuments">

      <div >
        <div *ngFor="let key of keys">

          <ul>
            <li class="promoted-checkbox cb-wrapper" *ngFor="let product of productsByCategory[key]" >
              <input id="checkbox-{{product.name_show}}" type="checkbox" class="promoted-input-checkbox"
                     name="product" (change)="addDocument(product.nameShort)"/>
              <label for="checkbox-{{product.name_show}}" class="label" style="font-size: 12px !important;">

                  <span>
                         <strong>{{product.name_show}}</strong>
                   </span>
              </label>
            </li>
          </ul>


        </div>
      </div>

    </div>
    <div style="margin: 2% 30% 2% 30%">
      <button class="button is-blue" (click)="displayInfoMessage()">MEHR INFOS</button>

      <app-modal [active]="displayInfo" (modalClosed)="displayInfo = false">
        <div class="card__box" style="text-align: justify" [innerHTML]="package.moreInfos"></div>
      </app-modal>
    </div>
  </div>
</div>
